"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _getDisplayName = require("b2b-components/utils/getDisplayName");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _swiper = _interopRequireWildcard(require("swiper"));
var _Arrow = require("../../Arrow");
var _excluded = ["onManufacturerLogoClick", "Image360ItemComponent", "ImageItemComponent", "VideoItemComponent"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var withContainer = function withContainer(Component) {
  var WithContainer = function WithContainer(props) {
    var onManufacturerLogoClick = props.onManufacturerLogoClick,
      Image360ItemComponent = props.Image360ItemComponent,
      ImageItemComponent = props.ImageItemComponent,
      VideoItemComponent = props.VideoItemComponent,
      originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
    var currentItemIndex = originalProps.currentItemIndex,
      currentPreviewItemIndex = originalProps.currentPreviewItemIndex,
      image360 = originalProps.image360,
      images = originalProps.images,
      imageUrl = originalProps.imageUrl,
      isMobile = originalProps.isMobile,
      isPreview = originalProps.isPreview,
      itemIndexArray = originalProps.itemIndexArray,
      onItemChange = originalProps.onItemChange,
      onItemClick = originalProps.onItemClick,
      prevItemIndex = originalProps.prevItemIndex,
      text = originalProps.text,
      title = originalProps.title,
      totalItemCount = originalProps.totalItemCount,
      videos = originalProps.videos;
    var swiperElement = (0, _react.useRef)(null);
    var swiper = (0, _react.useRef)(null);
    var videoStopObjectArray = []; //eslint-disable-line react-hooks/exhaustive-deps

    var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isAutoplayDirty = _useState2[0],
      setIsAutoplayDirty = _useState2[1];
    // the method below is necessary, to avoid appearing duplicate slides,
    // which are created by Swiper component (they don't have events handler)
    var setSlidesCorrectly = (0, _react.useCallback)(function () {
      if (swiper.current && swiper.current.isBeginning) {
        swiper.current.slideToLoop(itemIndexArray.length - 1);
      }
      if (swiper.current && swiper.current.isEnd) {
        swiper.current.slideToLoop(0);
      }
    }, [itemIndexArray, swiper]);
    var registerVideoStopObject = (0, _react.useCallback)(function (videoStopObject) {
      videoStopObjectArray[videoStopObject.videoIndex] = videoStopObject.onStop;
    }, [videoStopObjectArray]);
    var stopVideo = (0, _react.useCallback)(function (videoIndex) {
      videoStopObjectArray[videoIndex] && videoStopObjectArray[videoIndex]();
    }, [videoStopObjectArray]);
    var handleManufacturerLogoClick = (0, _react.useCallback)(function (e) {
      e.preventDefault();
      onManufacturerLogoClick === null || onManufacturerLogoClick === void 0 ? void 0 : onManufacturerLogoClick();
    }, [onManufacturerLogoClick]);

    // cleaning up after Swiper component (after initialization) - handling duplicate slides
    // it has to be done directly into HTML DOM because of Swiper operations
    var handleSwiperInit = (0, _react.useCallback)(function () {
      if (!isPreview) {
        var duplicateSlides = document.querySelectorAll('.cds-Modal .swiper-slide-duplicate');
        var _iterator = _createForOfIteratorHelper(duplicateSlides),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var slide = _step.value;
            // remove id attributes from duplicate slides - id is used to create zoom for images
            var imageMagicZoom = slide.querySelector('.MagicZoom');
            imageMagicZoom === null || imageMagicZoom === void 0 ? void 0 : imageMagicZoom.removeAttribute('id');
            // remove duplicate slides (iframes) for videos
            var videoIframe = slide.querySelector('iframe');
            videoIframe === null || videoIframe === void 0 ? void 0 : videoIframe.remove();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, [isPreview]);
    var handleSwiperSlideChange = (0, _react.useCallback)(function () {
      var swiperIndex;
      if (swiper.current && (typeof swiper.current.realIndex === 'number' || typeof swiper.current.realIndex === 'string')) {
        swiperIndex = swiper.current.realIndex;
      } else {
        swiperIndex = currentItemIndex;
      }
      setSlidesCorrectly();
      onItemChange === null || onItemChange === void 0 ? void 0 : onItemChange(itemIndexArray[swiperIndex]);
      if (window.MagicZoom && !isPreview) {
        window.MagicZoom.stop();
        window.MagicZoom.start("image".concat(itemIndexArray[swiperIndex]));
      }
    }, [currentItemIndex, isPreview, itemIndexArray, onItemChange, setSlidesCorrectly]);
    var swiperParams = (0, _react.useMemo)(function () {
      var initialSlide = itemIndexArray.indexOf(currentItemIndex) !== -1 ? itemIndexArray.indexOf(currentItemIndex) : 0;
      return {
        effect: 'fade',
        initialSlide: initialSlide,
        loop: true,
        modules: [_swiper.EffectFade, _swiper.Navigation],
        navigation: {
          nextEl: ".".concat(_Arrow.ARROW_CLASS_NAME_NEXT),
          prevEl: ".".concat(_Arrow.ARROW_CLASS_NAME_PREV)
        },
        on: {
          init: handleSwiperInit,
          slideChange: handleSwiperSlideChange
        },
        renderNextButton: function renderNextButton() {
          if (totalItemCount > 1) {
            return /*#__PURE__*/_react["default"].createElement(_Arrow.Arrow, {
              type: _Arrow.ARROW_TYPE.next,
              isPreview: isPreview
            });
          }
        },
        renderPrevButton: function renderPrevButton() {
          if (totalItemCount > 1) {
            return /*#__PURE__*/_react["default"].createElement(_Arrow.Arrow, {
              type: _Arrow.ARROW_TYPE.prev,
              isPreview: isPreview
            });
          }
        },
        simulateTouch: false,
        speed: 0,
        Swiper: _swiper["default"]
      };
    }, [currentItemIndex, handleSwiperInit, handleSwiperSlideChange, isPreview, itemIndexArray, totalItemCount]);
    var swiperItems = (0, _react.useMemo)(function () {
      var swiperItems = [];
      var itemIndex = 0;
      images === null || images === void 0 ? void 0 : images.map(function (image) {
        return swiperItems.push( /*#__PURE__*/_react["default"].createElement(ImageItemComponent, {
          image: image,
          imageUrl: imageUrl,
          isPreview: isPreview,
          onClick: onItemClick,
          title: title,
          isCurrentImage: currentItemIndex === itemIndexArray[itemIndex],
          itemIndex: itemIndexArray[itemIndex],
          key: itemIndex++,
          text: text
        }));
      });
      image360 && swiperItems.push( /*#__PURE__*/_react["default"].createElement(Image360ItemComponent, {
        image360: image360,
        imageUrl: imageUrl,
        isPreview: isPreview,
        onClick: onItemClick,
        title: title,
        key: itemIndex++
      }));
      videos === null || videos === void 0 ? void 0 : videos.map(function (video) {
        return swiperItems.push( /*#__PURE__*/_react["default"].createElement(VideoItemComponent, {
          isAutoplay: !isMobile && !isAutoplayDirty && itemIndex === currentItemIndex && currentItemIndex === currentPreviewItemIndex,
          onClick: onItemClick,
          title: title,
          isPreview: isPreview,
          itemIndex: itemIndexArray[itemIndex],
          video: video,
          key: itemIndex++,
          registerVideoStopObject: registerVideoStopObject,
          setIsAutoplayDirty: setIsAutoplayDirty
        }));
      });
      return swiperItems;
    }, [images, image360, Image360ItemComponent, imageUrl, isPreview, onItemClick, title, videos, ImageItemComponent, currentItemIndex, itemIndexArray, text, VideoItemComponent, isMobile, isAutoplayDirty, currentPreviewItemIndex, registerVideoStopObject]);
    (0, _react.useEffect)(function () {
      var _swiper$current;
      var activeItemIndex = itemIndexArray.indexOf(currentItemIndex);
      var swiperIndex = ((_swiper$current = swiper.current) === null || _swiper$current === void 0 ? void 0 : _swiper$current.realIndex) || 0;
      !isPreview && prevItemIndex && stopVideo(prevItemIndex);
      if (
      // mobileMenu tabs change
      swiper.current && !swiper.current.destroyed && activeItemIndex !== swiperIndex) {
        var _swiper$current2, _swiper$current2$slid;
        (_swiper$current2 = swiper.current) === null || _swiper$current2 === void 0 ? void 0 : (_swiper$current2$slid = _swiper$current2.slideToLoop) === null || _swiper$current2$slid === void 0 ? void 0 : _swiper$current2$slid.call(_swiper$current2, activeItemIndex);
      }
    }, [currentItemIndex, isMobile, isPreview, itemIndexArray, prevItemIndex, stopVideo, swiper]);
    (0, _react.useEffect)(function () {
      setTimeout(function () {
        var _swiperElement$curren;
        var swiperInstance = (_swiperElement$curren = swiperElement.current) === null || _swiperElement$curren === void 0 ? void 0 : _swiperElement$curren.swiper;
        if (!swiper.current) {
          swiper.current = swiperInstance;
        }
      }, 0);
    });
    var injectedProps = {
      onManufacturerLogoClick: handleManufacturerLogoClick,
      registerVideoStopObject: registerVideoStopObject,
      swiperElement: swiperElement,
      swiperItems: swiperItems,
      swiperParams: swiperParams
    };
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, originalProps, injectedProps));
  };
  WithContainer.displayName = "withContainer(".concat((0, _getDisplayName.getDisplayName)(Component), ")");
  (0, _hoistNonReactStatics["default"])(WithContainer, Component);
  return WithContainer;
};
exports.withContainer = withContainer;